global.webistePlanList = global.API_ADMIN_URL+'webistePlanList/';

global.adminAddWebistePlan = global.API_ADMIN_URL+'adminAddWebistePlan/';
global.adminEditWebistePlan = global.API_ADMIN_URL+'adminEditWebistePlan/';
global.webistePlanDetails = global.API_ADMIN_URL+'webistePlanDetails/';


global.adminAddSetupPlan = global.API_ADMIN_URL+'adminAddSetupPlan/';
global.adminEditSetupPlan = global.API_ADMIN_URL+'adminEditSetupPlan/';
global.adminSetupPlanList = global.API_ADMIN_URL+'adminSetupPlanList/';
global.setupPlanDetails = global.API_ADMIN_URL+'setupPlanDetails/';
global.setupPlanDelete = global.API_ADMIN_URL+'setupPlanDelete/';
global.setupPlanStatus = global.API_ADMIN_URL+'setupPlanStatus/';

global.adminAddMasterPlan = global.API_ADMIN_URL+'adminAddMasterPlan/';
global.adminEditMasterPlan = global.API_ADMIN_URL+'adminEditMasterPlan/';
global.adminMasterPlanList = global.API_ADMIN_URL+'adminMasterPlanList/';
global.masterPlanDetails = global.API_ADMIN_URL+'masterPlanDetails/';
global.masterPlanDelete = global.API_ADMIN_URL+'masterPlanDelete/';
global.masterPlanStatus = global.API_ADMIN_URL+'masterPlanStatus/';
